import { BaseType } from '../../base/base-type';
import { EmployerTypeIdEnum } from '../enum/employer-type-id.enum';

export class EmployerType extends BaseType {
  public declare id: EmployerTypeIdEnum;
}
